import styled from 'styled-components';
import { colors, fonts, media } from '../../../utils';

export const Container = styled.div`
    margin: 4rem
`;


export const Grid = styled.section`
    display: grid;
    justify-content: space-between;
    grid-gap: 3rem;
    grid-template-columns: 1fr 1fr;

    ${media.large`
        grid-template-columns: 1fr 1fr 1fr 1fr;
    `}
`;
